import React, {useState} from 'react';
import "../style/user_and_patient_form.scss";
import InputField from "../commons/InputField";
import {emptyPatientWithUserInfo, PatientWithUserInfo} from "../models/Patient";
import {googleServer} from "../commons/commonVariable";
import {useNavigate} from "react-router-dom";
import TopBar from "../commons/TopBar";
import { COUNTRY_OPTIONS } from "../commons/countries";



const UserAndPatientForm = () => {
    const [formData, setFormData] = useState<PatientWithUserInfo>(emptyPatientWithUserInfo);
    const [isLoading, setIsLoading] = useState<boolean>();
    const navigate = useNavigate();
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const {name, value} = e.target;
        console.log(value);
        setFormData({
            ...formData,
            [name]: value
        });
    }
    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setIsLoading(true);
        const [patientResponse] = await Promise.all([
            await fetch(googleServer + '/savePatientInfo', {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(formData),
                credentials: "include"
            }),
            await fetch(googleServer + '/user/updateUser', {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    institution: formData.institution,
                    department: formData.department,
                    country: formData.country,
                    collaboInterest: formData.collaboInterest
                }),
                credentials: "include"
            })
        ])
        setIsLoading(false);
        if (patientResponse.status === 201) {
            navigate("/welcome");
        }
    }

    return (
        <React.Fragment>
            <TopBar showGoogleSignIn={false} />
            <div style={{marginTop: '120px'}}>
                <link rel="preconnect" href="https://fonts.googleapis.com"/>
                <h2 style={{marginBottom: 0, fontWeight: 700, fontSize: '2rem'}}>Almost Done! Just a Few More Details</h2>
                <div style={{color: '#6b7280', fontSize: '1.4rem', marginBottom: '1.5rem'}}>Please complete the form below to continue</div>
                <form className="user-and-patient-form-container" onSubmit={handleSubmit}>
                    <div className="sub-form-box">
                        <span className="form-header">Your Information</span>
                        <span className="form-divider"></span>
                        <InputField
                            label="University/School/Institution (please give full name)"
                            type="text"
                            name="institution"
                            placeholder="Type Your university/school/institution"
                            onChange={handleChange}
                            required={true}
                            autoFocus={true}
                            className={"form-input"}
                            value={formData.institution}
                        />
                        <InputField
                            label="Department/Program"
                            type="text"
                            name="department"
                            placeholder="Type your department/program"
                            onChange={handleChange}
                            required={true}
                            className={"form-input"}
                            value={formData.department}
                        />
                        <InputField
                            label="Country"
                            type="select"
                            name="country"
                            placeholder="Select your country"
                            onChange={handleChange}
                            required={true}
                            className="form-input"
                            value={formData.country}
                            options={COUNTRY_OPTIONS}
                        />
                        <InputField
                            label="Are you open to potential collaboration on future simulation projects?"
                            type="radio"
                            name="collaboInterest"
                            onChange={handleChange}
                            required={true}
                            className="radio-option"
                            options={[
                                {label: "Yes", value: "yes"},
                                {label: "No", value: "no"}
                            ]}
                            value={formData.collaboInterest}
                        />
                        <label className="form-label">
                            <b>User information will be used for usability evaluation and feedback purposes only, and
                                will NOT be shared with third parties or used for any commercial purposes. </b>
                        </label>
                    </div>
                    <div className="sub-form-box">
                        <span className="form-header">Patient Information</span>
                        <span className="form-divider"></span>
                        <InputField
                            label="First Name"
                            type="text"
                            name="firstName"
                            placeholder="First Name"
                            onChange={handleChange}
                            required={true}
                            className={"form-input"}
                            value={formData.firstName}
                        />
                        <InputField
                            label="Last Name"
                            type="text"
                            name="lastName"
                            placeholder="Last Name"
                            onChange={handleChange}
                            required={true}
                            className={"form-input"}
                            value={formData.lastName}
                        />
                        <InputField
                            label="Sex"
                            type="radio"
                            name="sex"
                            onChange={handleChange}
                            required={true}
                            className="radio-option"
                            options={[
                                {label: "Male", value: "male"},
                                {label: "Female", value: "female"}
                            ]}
                            value={formData.sex}
                        />
                        <InputField
                            label="Date of Birth"
                            type="date"
                            name="birthday"
                            placeholder="Date of Birth"
                            onChange={handleChange}
                            required={true}
                            className={"form-input"}
                            value={formData.birthday}
                        />
                        <InputField
                            label="Chief Complain"
                            type="text"
                            name="chiefComplain"
                            placeholder="Chief Complain"
                            onChange={handleChange}
                            required={true}
                            className={"form-input"}
                            value={formData.chiefComplain}
                        />
                        <InputField
                            label="Allergy"
                            type="text"
                            name="allergy"
                            placeholder="Allergy"
                            onChange={handleChange}
                            required={true}
                            className={"form-input"}
                            value={formData.allergy}
                        />
                        <InputField
                            label="Primary Care Provider"
                            type="text"
                            name="primaryCareProvider"
                            placeholder="Primary Care Provider"
                            onChange={handleChange}
                            required={true}
                            className={"form-input"}
                            value={formData.primaryCareProvider}
                        />
                        {isLoading ? (<div className="spinner-user-and-patient-form"></div>) : (
                            <button type="submit" className="form-button" value="Submit">
                                Submit
                            </button>)
                        }
                    </div>
                </form>
            </div>
        </React.Fragment>
    );
}

export default UserAndPatientForm;